import React from 'react';
import PropTypes from 'prop-types';
import RsTooltip from '@Pages/RetroSynthesis/components/RsTooltip';
import { ButtonWithIcon } from '@els/els-react--button';
import { LinkOptionType } from '@Pages/RetroSynthesis/LinkOption/constants';
import cn from 'classnames';
import isNil from 'lodash/isNil';
import get from 'lodash/get';

import './LinkOption.scss';

// eslint-disable-next-line react/prop-types,react/function-component-definition
const LinkOption = ({ step, targetRect, onClosed, onOptionChecked }) => {
  const handleOptionClick = (optionType) => {
    onClosed();
    onOptionChecked(optionType);
  };

  if (!targetRect) {
    return null;
  }

  const hasStructure = !isNil(get(step, 'substance.structure'));

  return (
    <RsTooltip targetRect={targetRect} onClosed={onClosed}>
      <section className={cn('els-btn-group-vertical', 'link-option__content')}>
        <ButtonWithIcon
          sprite="ChevronRight"
          type="link"
          linkIconSize="xs"
          className={cn('u-els-margin-top-1o4', 'u-els-margin-bottom-1o4', 'e2e-drop-item', 'e2e-show-conditions-reaxys-examples')}
          onClick={() => handleOptionClick(LinkOptionType.SHOW_CONDITIONS)}>
          Show Conditions/Reaxys Examples
        </ButtonWithIcon>
        {hasStructure && (
          <ButtonWithIcon
            sprite="ChevronRight"
            type="link"
            linkIconSize="xs"
            className={cn('u-els-margin-top-1o4', 'u-els-margin-bottom-1o4', 'e2e-drop-item', 'e2e-add-reaction-step--one-step-only-')}
            onClick={() => handleOptionClick(LinkOptionType.ADD_REACTION_STEP)}>
            Add reaction step (one step only)
          </ButtonWithIcon>
        )}
        <ButtonWithIcon
          sprite="ChevronRight"
          type="link"
          linkIconSize="xs"
          className={cn('u-els-margin-top-1o4', 'u-els-margin-bottom-1o4', 'e2e-drop-item', 'e2e-delete-prior-step-s-')}
          onClick={() => handleOptionClick(LinkOptionType.DELETE_PRIOR_STEPS)}>
          Delete prior step(s)
        </ButtonWithIcon>
        <ButtonWithIcon
          sprite="ChevronRight"
          type="link"
          linkIconSize="xs"
          className={cn('u-els-margin-top-1o4', 'u-els-margin-bottom-1o4', 'e2e-drop-item', 'e2e-copy-reaction')}
          onClick={() => handleOptionClick(LinkOptionType.COPY_REACTION)}>
          Copy reaction
        </ButtonWithIcon>
      </section>
    </RsTooltip>
  );
};

LinkOption.propTypes = {
  step: PropTypes.object,
  onClosed: PropTypes.func,
  onOptionChecked: PropTypes.func,
};

LinkOption.defaultProps = {
  onClosed: () => null,
  onOptionChecked: () => null,
};

export default LinkOption;
